"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
const uikit_e_field_label_1 = require("../../common/components/uikit-e-field-label");
const dimension_input_1 = require("./dimension-input");
const aspect_ratio_lock_button_1 = require("./aspect-ratio-lock-button");
const warning_group_1 = require("./warning-group");
exports.DimensionField = ({ translate, actions, containerDimensions, originalContainerDimensions, aspectRatioLocked, warnings, disabled, onResetButtonClick, }) => {
    const formats = [
        { key: 'px', label: translate('imageDimensionPxFormat') },
        { key: 'auto', label: translate('imageDimensionAutoFormat') },
    ];
    const formatsWithPercent = [
        ...formats,
        { key: '%', label: translate('imageDimensionPercentFormat') },
    ];
    const isMobileTab = actions.getters.getIsMobileTab();
    return (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
        hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
            hyperapp_1.h(uikit_e_field_label_1.UiKitEFieldLabel, null,
                translate('containerDimensionsLabel'),
                hyperapp_1.h("e-tooltip", { type: "helper", content: translate('containerDimensionTooltip') })),
            hyperapp_1.h("div", { className: "e-grid e-grid-vertical_center e-grid-small" },
                hyperapp_1.h("div", { className: "e-cell e-cell-small" },
                    hyperapp_1.h(dimension_input_1.DimensionInput, { value: containerDimensions.widthValue, format: containerDimensions.widthFormat, formats: isMobileTab ? formatsWithPercent : formats, disabled: disabled, onValueChange: value => {
                            actions.effects.tracker({ action: 'containerDimensionValueChange', label: 'width' });
                            actions.effects.changeContainerDimensions({
                                dimensionType: 'active',
                                changes: { widthValue: value },
                            });
                        }, onFormatChange: (format) => {
                            actions.effects.tracker({ action: 'containerDimensionFormatChange', label: 'width' });
                            actions.effects.changeContainerDimensions({
                                dimensionType: 'active',
                                changes: { widthFormat: format },
                            });
                        } })),
                hyperapp_1.h("div", { className: "e-cell" },
                    hyperapp_1.h(aspect_ratio_lock_button_1.AspectRatioLockButton, { translate: translate, disabled: disabled || !containerDimensions.ratio, locked: !containerDimensions.ratio ? false : aspectRatioLocked, ratio: containerDimensions.ratio, originalRatio: originalContainerDimensions.ratio, onLockedChange: locked => {
                            actions.effects.tracker({ action: 'clickedAspectRatioLockButton' });
                            actions.setters.setAspectRatioLocked({ locked });
                        } })),
                hyperapp_1.h("div", { className: "e-cell e-cell-small" },
                    hyperapp_1.h(dimension_input_1.DimensionInput, { value: containerDimensions.heightValue, format: containerDimensions.heightFormat, formats: formats, disabled: disabled, onValueChange: value => {
                            actions.effects.tracker({ action: 'containerDimensionValueChange', label: 'height' });
                            actions.effects.changeContainerDimensions({
                                dimensionType: 'active',
                                changes: { heightValue: value },
                            });
                        }, onFormatChange: (format) => {
                            actions.effects.tracker({ action: 'containerDimensionFormatChange', label: 'height' });
                            actions.effects.changeContainerDimensions({
                                dimensionType: 'active',
                                changes: { heightFormat: format },
                            });
                        } })),
                hyperapp_1.h("div", { className: "e-cell e-cell-small" },
                    hyperapp_1.h("button", { className: "e-btn", onclick: () => onResetButtonClick(), disabled: disabled },
                        hyperapp_1.h("e-icon", { icon: "refresh" }),
                        translate('resetDimensionButtonLabel'))))),
        !disabled && (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
            hyperapp_1.h(warning_group_1.WarningGroup, { translate: translate, groupName: "container-dimensions", warnings: warnings })))));
};
//# sourceMappingURL=dimension-field.js.map